import React from 'react'
import StyledAnimationWrapper from "components/styled/AnimationWrapper.styled";
import StyledBackgroundWrapper from "components/styled/BackgroundWrapper.styled";
import sexOneBAnimation from "assets/animation/sex-one-b-animation.json";
import Lottie from "lottie-react";

const SvgSexOneBLearnMore = () => {
  return (
    <StyledBackgroundWrapper>
      <StyledAnimationWrapper top="22%" left="48%" width="10%">
        <Lottie animationData={sexOneBAnimation} loop={true} autoPlay={true} />
      </StyledAnimationWrapper>
    <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 961 1006"
    style={{
      enableBackground: "new 0 0 961 1006",
    }}
    xmlSpace="preserve"
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:none;}\n\t.st1{fill:#13A89E;}\n\t.st2{fill:#02594F;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#E8A18E;}\n\t.st5{fill:#9B5849;}\n\t.st6{opacity:0.2;fill:#9E695C;enable-background:new    ;}\n\t.st7{opacity:0.2;fill:#DD8172;enable-background:new    ;}\n\t.st8{fill:#824237;}\n\t.st9{fill:#8F493B;}\n\t.st10{fill:#844339;}\n\t.st11{fill:#9F5D4A;}\n\t\n\t\t.st12{opacity:0.2;fill:none;stroke:#DD8172;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;enable-background:new    ;}\n\t.st13{fill:#1A1A1A;}\n\t.st14{fill:#0F192D;}\n\t.st15{fill:#121D3B;}\n\t.st16{fill:#382632;}\n\t.st17{fill:#FFFFFF;}\n\t.st18{fill:#F2B668;}\n\t.st19{fill:#D89E60;}\n\t\n\t\t.st20{opacity:0.2;fill:none;stroke:#9E695C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;enable-background:new    ;}\n"
      }
    </style>
    <pattern
      y={1080}
      width={131}
      height={104}
      patternUnits="userSpaceOnUse"
      id="New_Pattern_Swatch_4"
      viewBox="0 -104 131 104"
      style={{
        overflow: "visible",
      }}
    >
      <g>
        <rect y={-104} className="st0" width={131} height={104} />
        <rect y={-104} className="st0" width={131} height={104} />
        <rect y={-104} className="st1" width={131} height={104} />
      </g>
    </pattern>
    <g>
      <g id="Layer_15">
        <path
          className="st2"
          d="M818.9,601.6c0.5-1-0.4,1.3,0.1,0.4c15.8-30.9,22.1-69.5,16-103.7C776.1,168.4,955,0,955,0H-1v1006 c303-300,500.9-238.8,627-272C681.9,719.3,791.6,652.6,818.9,601.6z"
        />
      </g>
      <g id="Layer_8">
        <g>
          <pattern
            id="SVGID_1_"
            xlinkHref="#New_Pattern_Swatch_4"
            patternTransform="matrix(1 0 0 -1 1320 -19564)"
          />
          <path
            className="st3"
            d="M626,733c55.9-14.7,165.6-81.4,192.9-132.4c0.5-1-0.4,1.3,0.1,0.4c15.8-30.9,22.1-69.5,16-103.7 C779.2,185,936.6,17.4,953.5,0.4c-19.9,6.2-238.1,82.1-315.5,450.3c-9.7,46.7-35.9,88.3-73.7,117.3 c-33.3,25.4-81.9,51.6-151.6,68.6C285,667.8,173,744.5,96.8,851.6c-29.9,41.9-62.3,92.2-96.5,152.1 C302.6,705.2,500.1,766.1,626,733z"
          />
        </g>
      </g>
      <g id="Layer_7">
        <path
          className="st4"
          d="M626,734c55.9-14.7,165.6-81.4,192.9-132.4c0.5-1-0.4,1.3,0.1,0.4c9.9-19.8,15.9-41.2,17.7-63.3 c-15.5-13.6-32.8-28-48.4-38.5c0,0-137.2-4-151.1-0.1s-74.3,17.1-98.5,29.9s-68.6,53.6-85.7,71.9c-8.6,9.1,3.1,80.1,17.4,151.3 C531.5,745.7,582.9,745.3,626,734z"
        />
      </g>
      <g id="People">
        <path
          className="st5"
          d="M435.7,453l-66.7-0.9l-0.3,21.9c-1.6,5.8-15.2,54-19.4,55.9l47.6,36.7l22,6.4c7.3,1.2,15.5,8.9,14,3 L435.7,453z"
        />
        <path
          className="st6"
          d="M433.9,499.2l-0.5,13.6c-47.9,2.2-64.5-39.4-64.5-39.4C381.3,476,433.9,499.2,433.9,499.2z"
        />
        <path
          className="st4"
          d="M751.9,503.8l-26.2-12.4c-5.1-5.6-7.6-13-7.1-20.5l2.9-47.7L632,436.4l-2.5,38.8c-0.3,4.6,0.5,35-21.7,45.9 c0,0-36.7,13.8-59.7,58c-14.4,27.8,105.7-22.8,105.7-22.8s31-7.5,47.7-13.9s30.8-20,30.8-20l15-14.2 C749,506.8,750.5,505.4,751.9,503.8z"
        />
        <path
          className="st7"
          d="M720.2,450.5c-21.2,17-59.7,35.4-91.8,11.5l1-16l92-19.2L720.2,450.5z"
        />
        <polygon
          className="st4"
          points="612,299 697.5,285.2 733.8,361.6 717.7,388.2 667.5,406.9 639.4,398.3 618.3,328.6  "
        />
        <path
          className="st4"
          d="M721.8,416.3c0,0-18.2-1.1-23.1-17.7c-0.1-0.2-21.4-91.4-53.4-92.1c-38-0.9-54.3,10.5-58.8,47.6 c-1.9,15.7-9.5,21.7-17.1,29.3c-3,3-0.3,8.8,4.3,8.1l5.5-0.1c1.2,0,2.3,0.9,2.4,2.2c1.4,21.1,10.8,50.6,17.4,55.9 c4.1,3.3,19.9,8.3,34.7,9.4C690.3,463,721.8,416.3,721.8,416.3z"
        />
        <path
          className="st8"
          d="M598.1,350.5c-0.9-2.9,0.6-4.1,5-4.5c4.5-0.2,8.9,0.5,13.1,2.2c8.4,3.4,11.7,11.5,9.4,9.9 c-3.9-2.7-7.2-4.3-16-6.2C604.7,351,598.7,352.5,598.1,350.5z"
        />
        <g>
          <path
            className="st9"
            d="M778.8,387.5c4-1.1,5.7-5.1,5.7-9.2c0-4.9-1.5-9.7-4.4-13.6c5.6-7.2,11.8-18.1,2.5-23.5 c5.3-2.4,6.5-8.9,5.5-14.9c-0.5-2.9-7.2-4.9-9.7-5.8c5.5-3.3,10.7-7.6,10.8-14.5c0.1-2.6-2.3-5.9-1.8-8c0.3-1.3,2.1-2.9,2.5-4.5 c0.4-1.5,0.6-3.1,0.4-4.7c-1-16.3-21.2-21.9-33.8-15c0.3-4.8-2.3-9.4-6.7-11.6c-4.9-2.6-10.4-1.4-15.2,1 c2.8-5.3,1.7-11.8-2.8-15.8c-5.9-5.2-14.2-3.9-20.4,0c1.6-7.7-6.6-13.9-13.7-15.4c-5.3-1-10.7-0.3-15.5,2c-2.2,1.1-3.8,2.7-5.8,4 c-2.8,1.8-2.1,1.2-5.1-0.8c-4.5-3-9.9-4.2-15.2-3.4c-2.5,0.4-4.9,1.3-7.2,2.6c-1.8,1-3.6,3.7-5.4,4.4c-2,0.8-3.4-2-5.6-3.3 c-1.8-1-3.7-1.6-5.8-1.8c-4.6-0.3-8.5,1.8-11.5,5.1c-1-2.8-3.1-5.6-6.3-5.7c-1.6,0-3.2,0.5-4.5,1.4c-0.9,0.6-1.6,1.5-2.1,2.4 c-7.2,0.4-15.3,1.3-20.2,7.2c-3.1,3.8-3.5,9,0.1,12.1c-7,2.5-13.3,7.7-14,15.6c-0.4,4.4,1.7,9.5,5.6,10.5 c-4.8,3.3-7.2,9.2-7.1,15.2c0.2,6.8,5.1,10.5,11.1,8.6c-2.2,6,0.8,12.7,6.8,14.9c2.5,0.9,5.2,1,7.7,0.1 c2.3,10.4,19.9,12,27.1,4.9c2.2,0.2,4.5-0.3,6.5-1.4c-0.8,5.4,2.8,10.4,8.2,11.2c1.7,0.3,3.4,0.1,5-0.5 c-2.1,7.4,3,18.4,11.2,16.8c-2.1,6.5-1.8,13.3,5,17c1.9,1,10.5,3.9,14.2,3.1c0.6,3.1,4.2,7.6,5.1,8.9c2.4,3.5,6.1,9.5,6.1,9.5 c1.2,3.1,3.3,6,6.4,6.9c-2.1,4.2-1,10,4.1,11.5c1.6,0.5,3.3,0.4,4.9-0.3c-1.3,5.4,1.8,12.6,7.3,13.3c-7.5,9.9,3.6,27.7,11.3,24.2 c2.2,4.3,6.4,7.2,11.2,7.5c5.6,0.2,8.3-4.2,10.1-6.8c1.4,2.2,6.5,3,8.9,1.8c4.3-2.2,6.5-7,5.2-12.2c6.3,4.8,16.9-6.2,13.2-12.7 c8.3-0.3,13.2-12.2,7-18C784.2,405.6,784.2,393,778.8,387.5z"
          />
          <path
            className="st10"
            d="M583.3,307.5c-0.5-3.8-0.4-8,2.2-11.1c2-2.5,5.5-3.8,8.5-2.6l-1.2,0.8c0.5-5.1,3.7-9.5,8.4-11.6 c4.2-1.7,9.9-0.4,10.3,4.8c0.1,1.1-1.7,1.1-1.8,0c-0.3-1.9-1.8-3.4-3.7-3.7c-2-0.2-4,0.3-5.6,1.4c-3.2,2-5.4,5.4-5.8,9.2 c0,0.5-0.4,0.9-0.9,0.9c-0.1,0-0.2,0-0.2,0c-2.6-0.9-5.5,0.1-7,2.5c-1.8,2.6-1.8,6-1.4,9.1C585.2,308.2,583.5,308.7,583.3,307.5 L583.3,307.5z"
          />
          <path
            className="st10"
            d="M644.6,240.3c5.3,2.4,8.6,7.9,8.3,13.7l-1.7-0.5c2-2.9,6.2-3,9-1.3c3.3,2,5,5.8,4.5,9.6 c-0.2,1.1-2,1.1-1.8-0.1c0.5-2.9-0.7-5.9-3.1-7.7c-2-1.5-5.5-2-7.2,0.4c-0.3,0.4-0.8,0.5-1.2,0.3c-0.3-0.2-0.4-0.5-0.4-0.8 c0.3-5-2.5-9.7-7-11.9C643.1,241.6,643.6,239.8,644.6,240.3L644.6,240.3z"
          />
          <path
            className="st10"
            d="M709.7,423c2.9-0.4,5.6-1.7,7.7-3.8c1.1-1,2-2.1,2.8-3.3c0.7-1.1,2.2-2.9,1.5-4.2l1.7-0.6 c1.3,4,6.1,4.7,9.5,3c3.5-1.8,5.7-5.5,5.7-9.4c0.1-0.5,0.5-0.8,1-0.8c0.4,0.1,0.7,0.4,0.8,0.8c0,5-3.1,9.5-7.8,11.4 c-4.3,1.6-9.4,0-10.9-4.6c-0.3-1,1.2-1.5,1.7-0.6c1.6,3-2,6.8-3.9,8.8c-2.4,2.7-5.7,4.5-9.3,5C709,424.9,708.5,423.1,709.7,423z"
          />
          <path
            className="st10"
            d="M691.6,323.9c-2.5,3.3-1.9,8,1.4,10.5s8,1.9,10.5-1.4c0.7-0.8,1.6,0.2,1.5,0.9c-0.8,4,1.8,8,5.8,8.8 c3.3,0.7,6.6-1,8.1-4c0.6-1,2.1,0,1.5,1c-2.4,4.5-8,6.2-12.5,3.8c-3.7-1.9-5.6-6.1-4.7-10.1l1.5,0.9c-3.3,3.9-9.2,4.4-13.1,1.1 c-3.7-3.1-4.3-8.5-1.5-12.5C690.8,322,692.3,323,691.6,323.9L691.6,323.9z"
          />
          <path
            className="st10"
            d="M756.8,274.5c-3,1.7-5.3,4.5-6.4,7.7c-1.1,3.2,0.5,6.2,2.6,8.6c0.3,0.4,0.3,1-0.1,1.3 c-0.2,0.1-0.4,0.2-0.6,0.2c-3.3-0.3-6.8,1.3-7.8,4.7c-0.9,2.8,0.7,5.8,3.5,6.6c0.5,0.1,1,0.2,1.5,0.2c0.5,0.1,0.8,0.5,0.8,1 c-0.1,0.4-0.4,0.7-0.8,0.8c-3.9,0-7-3.2-7-7c0-0.4,0-0.9,0.1-1.3c0.8-4.6,5.2-7.2,9.7-6.8c-0.2,0.5-0.5,1-0.7,1.5 c-2.4-2.7-4.2-6.1-3.2-9.9c1.2-3.9,3.9-7.3,7.5-9.3c0.5-0.2,1,0,1.2,0.5C757.3,273.8,757.2,274.2,756.8,274.5L756.8,274.5z"
          />
          <path
            className="st10"
            d="M687.6,278.1c0.9,4.1,5.5,5.1,9,4.1c3.3-0.9,6.1-3.2,7.7-6.3c0.3-0.4,0.8-0.5,1.3-0.2 c0.1,0.1,0.2,0.2,0.3,0.3c3,5.3,9.6,2.1,12.9-0.9c0.9-0.8,2.1,0.5,1.2,1.3c-2.3,2.1-5.1,3.9-8.3,4.2c-3,0.3-5.9-1.2-7.4-3.8 l1.5,0.1c-2,3.9-5.9,6.7-10.3,7.4c-4.2,0.6-8.7-1.4-9.7-5.8c-0.1-0.5,0.2-1,0.7-1.1C686.9,277.4,687.4,277.7,687.6,278.1 L687.6,278.1z"
          />
          <path
            className="st10"
            d="M754.6,374.9c-0.6-4,0.3-8.3,3.7-10.8c2.9-2.1,7.2-1.9,9.5,1.1l-1.4,0.1c1.1-2.1,3.1-3.6,5.5-3.9 c2.8-0.3,5.6,0.5,7.8,2.1c0.4,0.3,0.5,0.8,0.3,1.3s-0.8,0.5-1.3,0.3c-1.9-1.4-4.1-2-6.5-1.9c-1.9,0.2-3.6,1.4-4.4,3.1 c-0.3,0.4-0.8,0.5-1.3,0.3c-0.1,0-0.1-0.1-0.2-0.1c-1.8-2.2-5.1-2.6-7.3-0.7c-0.1,0-0.1,0.1-0.2,0.1c-2.6,2.1-3.2,5.6-2.7,8.7 C756.4,375.6,754.7,376,754.6,374.9L754.6,374.9z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M696.4,382.8c-4.5,6.8-11.1,10.4-17.9,6c-6.4-4.1-8.6-12.4-5.1-19.1c3.7-7.3,11.9-10.4,18.4-7.2 C703.7,368.1,700.7,376.2,696.4,382.8z"
          />
          <path
            className="st7"
            d="M690.8,371.5c0-0.5-0.4-0.8-0.8-0.9c-2.3,0.1-4.4,0.9-6.2,2.3c-1.9,1.6-3.3,3.7-4.2,6 c-0.4,1,1.2,1.5,1.6,0.5c0.6-1.6,1.5-3,2.7-4.3l0,0l0.3,0.1c0.2,0.1,0.4,0.2,0.6,0.4l0.1,0.1l0.2,0.2c0.1,0.1,0.3,0.3,0.4,0.4 l0,0v0l0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.4c0,0,0,0,0,0.1l0.1,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4s0,0.1,0,0.2 l0,0c0,0.1-0.1,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3l0,0v0.1l-0.1,0.2c-0.1,0.1-0.1,0.2-0.2,0.3l-0.1,0.1v0 c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3,0.3c0.2-0.2,0,0,0,0l-0.2,0.1c-0.1,0.1-0.2,0.1-0.4,0.2l-0.2,0.1c0.2-0.1,0,0-0.1,0 c-0.4,0.1-0.7,0.6-0.6,1c0.1,0.4,0.6,0.7,1,0.6c0.8-0.2,1.5-0.7,2.1-1.2c1-1,1.5-2.5,1.3-3.9c-0.3-1.3-1.2-2.4-2.3-3.1 c1.4-0.9,3-1.5,4.7-1.6C690.4,372.2,690.7,371.9,690.8,371.5z"
          />
        </g>
        <path
          className="st4"
          d="M302.2,621.7c-10.1-3.5-14,10.2-8.7,22.6s6.9,31.2,8.2,37.3s-0.5,20.7,0.6,24s-4.9,4.2,0.9,23.8 s12.6,26.4,22,31.5S375,772,375,772s-8.4-11.3-8.5-13.2s16,3.3,27.2,0.9s18.6-8.4,14.3-14.5s-21.3-2.6-28-3.3s-18.7-3.1-18.7-3.1 s15.6-5.5,30.3-11.2s25.6-12,21-20.9s-10.7-7.5-20.3-2.4c-27.3,14.5-46.5,15.9-46.5,15.9c6-6.1,13.2-11,21.1-14.3 c12.3-4.9,30.9-7.5,34.6-15.1s-4.6-15.5-14.3-12.8s-27.2,9.1-37.5,13.3s-13.5,7.4-14.8,6.2s-0.7-9.9,8.3-16.6s20.5-13.4,21.8-19.8 s-2.7-13.4-14.7-9.2s-18,10.5-24.6,16.4l-6.7,5.9c-4.2-8.8-7.8-18-10.7-27.3C303.5,631.1,304.8,622.5,302.2,621.7z"
        />
        <path
          className="st11"
          d="M345.6,530c0,0,5.8-2.9,14.4-1c19.8,4.4,60.3,22.6,121,77l-99-3L345.6,530z"
        />
        <path className="st12" d="M638,557c0,0-4.1-17.4-53.4-10.5" />
        <path className="st12" d="M665.6,556c0,0,4.1-16,53.4-9.7" />
        <path
          className="st11"
          d="M645.9,634.5c34.3-40.7,69.1-86.2,69.3-89.4s-1.1-16.7,4.4-37.3s16-36.7,22.6-42.5s17.7-5.8,17.7-5.8 c-0.4-2,0.1-4,1.4-5.6c2.1-2.7,11-0.2,12.4,3.1c0.8,2.1,1.1,4.5,0.6,6.7c0,0,4.9-3.7,9.8-1.6s7,10,7,10s9,0.9,10.8,7.4 s1.3,9.4,1.3,9.4s10.6,4.1,12.2,12.6s2.5,12.5-2.8,18.7s-27,28.5-38.8,39.2s-17.2,13.2-18.9,15.7s-59.4,102.4-59.4,102.4 s-10.4-14.8-21.6-25.6S645.9,634.5,645.9,634.5z"
        />
      </g>
      <g id="eyes">
        <path
          className="st13"
          d="M480.5,417.4c-10.6,1.5-21.1-2.3-20.9-4.7s1.5-4.1,4.3-2.3S482.3,417.1,480.5,417.4z"
        />
        <path
          className="st13"
          d="M471.5,378.3c-1.1-0.5-1.6-1.7-1.1-2.8c0.2-0.5,0.7-1,1.3-1.2c11.7-4,20.3-0.5,20.8-0.3l0,0 c1.1,0.5,1.6,1.7,1.2,2.8c-0.5,1.1-1.7,1.6-2.8,1.2l0,0c-0.1,0-7.6-3-17.8,0.4C472.5,378.6,472,378.6,471.5,378.3z"
        />
        <path
          className="st14"
          d="M510.5,469.3c3.8-6.4,5.8-13.3,8.7-20.1c3.3-7.7,2.7-16.5-1.5-23.8c-3.7-6.2-9.9-10.9-12.5-17.6 c-3.9-10.3,2-22.7-2.9-32.6c-19,33.1-32.9,68.8-41.4,106c-0.9,4.1-1.4,9.2,2.1,11.5l-0.4-0.8c6.6-1.3,15.2,13.2,21.8,14.5 c12.6,2.5,5.6,13.9,20.6,14.1C501.8,513.4,503.4,481.1,510.5,469.3z"
        />
        <path
          className="st11"
          d="M368.1,427.1c1.2-0.9,2.5-1.7,3.9-2.4c3.3-1.2-1.3-6.5-1.3-10.1c0.6-46.3,29.6-85.2,64.7-82.9 c41.6,2.7,58.3,16.8,59.6,57.7c0.5,17.4,8.3,24.7,15.9,33.7c3,3.5-0.6,9.7-5.5,8.4l-6-0.7c-1.4-0.1-2.6,0.8-2.8,2.2 c-6,38.3-22.6,66.8-63.2,66.2c-51.5-0.6-72.4-33.9-80-45.9C353.3,453.3,367.5,437.8,368.1,427.1z"
        />
        <path
          className="st11"
          d="M358.4,409.8c-0.1,10.5,7.3,19.1,16.7,19.2s17-8.3,17.2-18.8s-7.3-19.1-16.7-19.2S358.6,399.3,358.4,409.8z"
        />
        <path
          className="st6"
          d="M370,401.6c0.2-0.5,0.7-0.8,1.2-0.7c2.4,0.9,4.5,2.5,6.1,4.6c1.5,2.4,2.4,5.1,2.6,7.9c0.1,1.2-1.8,1.2-1.9,0 c-0.1-1.9-0.7-3.8-1.5-5.6l0,0l-0.4,0.1c-0.2,0.1-0.5,0.1-0.7,0.2l-0.2,0.1l-0.3,0.1c-0.2,0.1-0.4,0.2-0.6,0.3l0,0l-0.1,0 l-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.4c0,0,0,0,0,0.1l-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2v0.1c0,0.1-0.1,0.3-0.1,0.4s0,0.1,0,0.2l0,0 c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.4l0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.3,0.1,0.4l0.1,0.2v0.1 c0.1,0.1,0.1,0.3,0.2,0.4l0.2,0.4c-0.1-0.2,0,0,0,0l0.1,0.2c0.1,0.1,0.2,0.2,0.4,0.4l0.2,0.1c-0.2-0.2,0,0,0.1,0 c0.4,0.4,0.4,1,0,1.4c-0.3,0.3-0.7,0.4-1,0.3c-0.8-0.5-1.4-1.2-1.9-2.1c-0.8-1.5-0.9-3.2-0.1-4.7c0.8-1.3,2.1-2.3,3.6-2.6 c-1.2-1.5-2.8-2.6-4.6-3.3C370.2,402.6,369.9,402.1,370,401.6z"
        />
        <path
          className="st15"
          d="M515.6,367.4c-0.5-12-4.2-24.2-12.6-32.8c-4.7-4.8-10.6-8.3-16.5-11.7l-20-11.6c-4.9-2.9-9.9-5.7-15.5-7 c-6.7-1.5-14.6,0.2-18.2,6c-7-6.8-17.1-9.8-26.8-9.6s-19.2,3.4-28,7.5c-11.5,5.4-22.8,13.4-27.1,25.3c-1.9,5.3-2.3,11.1-4.7,16.2 c-6.7,14-26.7,19-30.4,34c-0.5,1.9-0.6,3.9-0.6,5.9c-0.4,5.8,1.5,11.8,3,17.5c0.8,3.1,1.3,6.2,1.5,9.4c-0.1,3.2-1.1,6.4-2.9,9.1 c-2.2,3.1-5.5,5.2-8.2,7.9c0,0-15.6,24.1,18.1,29.7s15.5-6.2,53.3,11.6c-1.8-2.7,0.1-6.2,0.8-8.4c1.6-4.5,4.5-8.6,4.6-13.4 c0-0.5,0-0.9,0-1.4c0-0.3,0.1-0.6,0.1-0.9c0.2-7.4-6.3-13-11.9-17.9s-10.8-10.2-13.4-17c-0.8-2.1-1.2-4.4-1.4-6.6 c0.1-4.3,2-8.3,5.2-11.2c5.5-4.8,13.7-4.5,20.9-5.5c10.2-1.5,20.4-6.8,25.5-15.8c3.6-6.3,4.4-13.8,7.5-20.3 c7.3-15.4,28.4-22.2,43.4-14.1c0,0,30.5,17.7,33.3,40.1l0.4,6.8l4.1-2.7c1.4,4.1,2.5,8.3,3.2,12.6c9.8-4.9,13.3-17.1,13.2-28.1 C515.7,369.8,515.7,368.6,515.6,367.4z"
        />
        <path
          className="st15"
          d="M480.8,385.5c0.8-2.9-1-3.6-6.1-2.9c-5.2,0.9-10.3,2.7-14.9,5.3c-9.5,5.2-12.6,13.5-10.1,11.5 c4.2-3.5,7.9-5.8,18-9.7C473.1,387.6,480.2,387.5,480.8,385.5z"
        />
        <ellipse className="st16" cx={474.8} cy={410.5} rx={4.4} ry={5} />
        <ellipse
          transform="matrix(0.9513 -0.3084 0.3084 0.9513 -115.2671 170.5567)"
          className="st17"
          cx={482}
          cy={450}
          rx={5}
          ry={4}
        />
        <ellipse className="st17" cx={596.5} cy={411.5} rx={5.5} ry={3.5} />
        <path
          className="st16"
          d="M605.2,370.3c0.3,2.4-1.1,4.6-3.1,4.8s-3.8-1.6-4-4s1.1-4.6,3-4.8S604.9,367.9,605.2,370.3z"
        />
      </g>
      <g id="light">
        <path
          className="st11"
          d="M372.8,771.5c106-28.2,188.9-20.6,253.2-37.5c12.2-3.2,26.8-8.8,42.7-16.3c15.5-21.4,28.3-41.2,29.3-44.7 c2.3-8-44-48-50.2-40.6c-5.2,6.2-55.8,56.6-59.8,54.5S551.7,662.7,545,657c-7-6-40.9-34.8-64-51s-104.4-65.8-128.2-76.2 c-7.1-3.1-21.3,6.8-31,18.8c-10.8,13.3-28.6,66.7-19.4,88.9C310,655.8,354.4,735.3,372.8,771.5z"
        />
        <line className="st12" x1={559} y1={642} x2={562.7} y2={669.9} />
      </g>
      <g id="Layer_11">
        <g>
          <path
            className="st18"
            d="M513.7,0H-1l-1,744C-2,744,297.4,630,513.7,0z"
          />
          <path
            className="st19"
            d="M513.7,0c0,0-156.5,496.3-425.6,687.6c0,0-61.1-11.6-90.1-63.6C-2,624,229,504,513.7,0z"
          />
        </g>
      </g>
      <g id="Layer_14">
        <path className="st20" d="M401.5,690.8c0,0,9.6,24.6,94.5,58.2" />
      </g>
    </g>
  </svg>
  </StyledBackgroundWrapper>
  )
}

export default SvgSexOneBLearnMore